module.exports = __webpack_public_path__ + "img/car-at-pole.a85a6254.png";